import * as React from 'react';

interface IRadioInputSwitchProps {
    name: string;
    id: string;
    label: string;
    icon?: string;
    onChange: (e: any) => void;
    checked?: boolean;
    disabled?: any;
    error?: any;
    wrapperClass?: string;
}

const RadioInputSwitch = (props: IRadioInputSwitchProps) => {
    let wrapperClass = 'radio-switch-radio radio-for-label';
    if (props.error && props.error.length > 0) {
        wrapperClass += ' has-error';
    }

    if (props.wrapperClass) {
        wrapperClass += ' ' + props.wrapperClass;
    }

    return (
        <span className={wrapperClass}>
            <input
                type="radio"
                name={props.name}
                id={props.id}
                className="form-control"
                checked={props.checked}
                disabled={props.disabled}
                onChange={props.onChange}
            />
            <label htmlFor={props.id}>
                {props.icon && <i className="material-icons">{props.icon}</i>}
                {props.label}
            </label>
            {props.error && <div className="alert alert-danger">{props.error}</div>}
        </span>
    );
};

export default RadioInputSwitch;
